import React from 'react';

const Badge = ({ text }) => {
    return <span className='badge'>{text}</span>;
};

export default Badge;
